import { PermissionGate } from '@shared/ui/PermissionGate'
import { AdminActionRequiredScreen } from '@features/admin/ui/AdminActionRequiredScreen'

export function AcaoNecessariaPage() {
  return (
    <PermissionGate permission="USER_READ">
      <AdminActionRequiredScreen />
    </PermissionGate>
  )
}
